<div class="text-muted">
	Camera is not user configurable.
</div>
